<!--  A /fegyelmi útvonalon (osztályfőnök) saját fejléccel, az Adminban a keret fejlécével. -->
<ng-container *ngIf="onallo; else tartalom">
  <ion-header [translucent]="true">
    <ion-toolbar color="primary">
      <ion-buttons slot="start"><ion-menu-button></ion-menu-button></ion-buttons>
      <ion-title>Fegyelmi eljárások</ion-title>
    </ion-toolbar>
  </ion-header>
  <ion-content>
    <ng-container *ngTemplateOutlet="tartalom"></ng-container>
  </ion-content>
</ng-container>

<ng-template #tartalom>
<ion-card>
  <ion-card-header>
    <ion-card-title>Fegyelmi eljárások</ion-card-title>
    <ion-card-subtitle>
      Az eljárás lépései a jogszabály sorrendjében (egyeztető eljárás felajánlása → megindítás és tárgyalás →
      határozat → kézbesítés → véglegesség). A <b>kötelező értesítést</b> a rendszer a lépés mentésekor azonnal
      kiküldi a tanulónak és – kiskorú tanulónál – a gondviselőknek (rendszerüzenet, push, e-mail).
      <b>Ez az értesítés nem minősül közlésnek</b> (Nkt. 58. § (3)): a postai értesítést és a határozat postai
      megküldését továbbra is el kell végezni.
    </ion-card-subtitle>
  </ion-card-header>
  <ion-card-content>
    <p *ngIf="hiba" class="fe-hiba">{{ hiba }}</p>

    <!-- ─────────── LISTA -->
    <ng-container *ngIf="!adatlap && jog">
      <div class="fe-fejsor">
        <ion-searchbar class="fe-kereso" placeholder="Tanuló, kötelességszegés, ügyszám…" mode="md"
                       [(ngModel)]="kereses" (ionChange)="betolt()" [debounce]="400"></ion-searchbar>
        <ion-select label="Állapot" label-placement="stacked" interface="popover" style="min-width:200px"
                    [(ngModel)]="szuroAllapot" (ionChange)="betolt()">
          <ion-select-option value="">Mind</ion-select-option>
          <ion-select-option *ngFor="let a of allapotLista" [value]="a.kulcs">{{ a.nev }}</ion-select-option>
        </ion-select>
        <ion-button size="small" (click)="ujEljaras()" *ngIf="kezel">
          <ion-icon slot="start" name="add-outline"></ion-icon>Új eljárás
        </ion-button>
        <ion-button size="small" fill="outline" (click)="betolt()" [disabled]="toltodik">
          <ion-icon slot="start" name="refresh-outline"></ion-icon>Frissítés
        </ion-button>
      </div>
      <p *ngIf="!kezel" class="fe-megj">
        Osztályfőnökként a saját osztályod tanulóinak eljárásait látod (csak olvasás). Rögzíteni az igazgató és a
        „Fegyelmi eljárások” admin-területre felvett munkatárs tud.
      </p>

      <!-- Új eljárás -->
      <div class="fe-urlap" *ngIf="ujNyitva">
        <h4>Új fegyelmi eljárás (előkészítés)</h4>
        <div class="fe-mezok">
          <div class="fe-tanulo-kereso">
            <ion-searchbar placeholder="Tanuló neve, osztálya vagy oktatási azonosítója" mode="md"
                           [(ngModel)]="tanuloKeres" (ionChange)="tanulokKeres()" [debounce]="350"></ion-searchbar>
            <ion-select label="Tanuló" label-placement="stacked" interface="popover" [(ngModel)]="uj.oktazon" (ionChange)="tanuloValt()">
              <ion-select-option *ngFor="let t of tanulok" [value]="t.oktazon">
                {{ t.nev }}{{ t.osztaly_nev ? ' – ' + t.osztaly_nev : '' }}
              </ion-select-option>
            </ion-select>
          </div>
          <ion-input label="A kötelességszegés napja" label-placement="stacked" type="date" [(ngModel)]="uj.kotelessegszeges_napja"
                     helperText="Három hónapon túl nem indítható eljárás (53. § (1))"></ion-input>
          <ion-input label="Büntető-/szabálysértési határozat közlése (ha volt)" label-placement="stacked" type="date"
                     [(ngModel)]="uj.bunteto_kozles_napja" helperText="Ekkor a három hónap ettől fut (53. § (1))"></ion-input>
          <ion-input label="Ügyszám / iktatószám" label-placement="stacked" [(ngModel)]="uj.ugyszam"></ion-input>
          <ion-input label="A sérelmet elszenvedő fél (egyeztetéshez; a családnak nem megy ki)" label-placement="stacked"
                     [(ngModel)]="uj.sertett_fel"></ion-input>
        </div>
        <ion-textarea label="A tanuló terhére rótt kötelességszegés" label-placement="stacked" [autoGrow]="true"
                      [(ngModel)]="uj.kotelessegszeges"
                      helperText="Ez kerül az értesítésekbe (56. § (2): a kötelességszegés megjelölése)."></ion-textarea>
        <ion-toggle [(ngModel)]="uj.tanulo_kerte" labelPlacement="end">
          A tanuló (kiskorúnál a szülő) maga ellen kérte – a megindítás és a lefolytatás kötelező (Nkt. 58. § (3))
        </ion-toggle>
        <div class="fe-gombsor">
          <ion-button size="small" (click)="ujMent()" [disabled]="mentes || !uj.oktazon || !uj.kotelessegszeges">
            <ion-icon slot="start" name="save-outline"></ion-icon>Felvétel
          </ion-button>
          <ion-button size="small" fill="clear" (click)="ujNyitva = false">Mégsem</ion-button>
        </div>
      </div>

      <div style="overflow-x:auto" *ngIf="lista.length; else nincs">
        <table class="fe-tabla">
          <thead>
            <tr><th>Tanuló</th><th>Kötelességszegés</th><th>Állapot</th><th>Megindítás</th><th>Tárgyalás</th><th>Döntés</th><th></th></tr>
          </thead>
          <tbody>
            <tr *ngFor="let e of lista" (click)="megnyit(e.id)" class="fe-sor">
              <td>{{ e.tanulo_nev || e.oktazon }}<br><small>{{ e.osztaly_nev }}</small></td>
              <td class="fe-rovid">{{ e.kotelessegszeges }}</td>
              <td>{{ e.allapot_nev }}
                <ion-badge color="danger" *ngIf="e.ertesites_hiba > 0">értesítés: hiba</ion-badge></td>
              <td>{{ e.meginditas_napja || '—' }}</td>
              <td>{{ e.targyalas_ido || '—' }}</td>
              <td>{{ e.dontes === 'megszuntetes' ? 'megszüntetés' : (e.buntetes ? buntetesNev(e.buntetes) : '—') }}</td>
              <td><ion-icon name="chevron-forward"></ion-icon></td>
            </tr>
          </tbody>
        </table>
      </div>
      <ng-template #nincs>
        <p class="fe-megj" *ngIf="!toltodik">Nincs fegyelmi eljárás.</p>
      </ng-template>
    </ng-container>

    <!-- ─────────── ADATLAP -->
    <ng-container *ngIf="adatlap">
      <div class="fe-fejsor">
        <ion-button size="small" fill="outline" (click)="bezar()">
          <ion-icon slot="start" name="arrow-back-outline"></ion-icon>Vissza a listához
        </ion-button>
        <ion-button size="small" fill="clear" (click)="frissit()">
          <ion-icon slot="start" name="refresh-outline"></ion-icon>Frissítés
        </ion-button>
      </div>

      <h3 class="fe-cim">
        {{ adatlap.eljaras.tanulo_nev || adatlap.eljaras.oktazon }}
        <small>{{ adatlap.eljaras.osztaly_nev }}</small>
        <ion-badge color="primary">{{ adatlap.eljaras.allapot_nev }}</ion-badge>
      </h3>
      <p class="fe-megj">
        {{ adatlap.eljaras.kiskoru ? 'Kiskorú tanuló: az értesítés a tanulónak és a gondviselőinek megy.' : 'Nagykorú tanuló: az értesítés a tanulónak megy (a gondviselőt a jogszabály nem nevezi meg).' }}
        {{ adatlap.eljaras.tankoteles ? 'Tanköteles (Nkt. 58. § (5) korlátai).' : '' }}
        Felvette: {{ adatlap.eljaras.letrehozta }} ({{ adatlap.eljaras.letrehozva }}){{ adatlap.eljaras.megindito ? ' · megindította: ' + adatlap.eljaras.megindito : '' }}
      </p>

      <!-- Fejadatok -->
      <div class="fe-blokk">
        <div *ngIf="!fejSzerkeszt">
          <p><b>A tanuló terhére rótt kötelességszegés:</b><br><span class="fe-pre">{{ adatlap.eljaras.kotelessegszeges }}</span></p>
          <p class="fe-megj">
            A kötelességszegés napja: {{ adatlap.eljaras.kotelessegszeges_napja || '—' }}
            · Ügyszám: {{ adatlap.eljaras.ugyszam || '—' }}
            · Sértett: {{ adatlap.eljaras.sertett_fel || '—' }}
            {{ adatlap.eljaras.tanulo_kerte == 1 ? '· A tanuló maga ellen kérte' : '' }}
          </p>
          <ion-button size="small" fill="outline" *ngIf="adatlap.kezel" (click)="fejSzerkeszt = true">Fejadatok módosítása</ion-button>
          <ion-button size="small" fill="clear" color="danger" *ngIf="adatlap.kezel" (click)="eljarasTorol()">Törlés</ion-button>
        </div>
        <div *ngIf="fejSzerkeszt">
          <ion-textarea label="Kötelességszegés" label-placement="stacked" [autoGrow]="true" [(ngModel)]="fej.kotelessegszeges"></ion-textarea>
          <div class="fe-mezok">
            <ion-input label="A kötelességszegés napja" label-placement="stacked" type="date" [(ngModel)]="fej.kotelessegszeges_napja"></ion-input>
            <ion-input label="Büntető-/szabálysértési határozat közlése" label-placement="stacked" type="date" [(ngModel)]="fej.bunteto_kozles_napja"></ion-input>
            <ion-input label="Ügyszám" label-placement="stacked" [(ngModel)]="fej.ugyszam"></ion-input>
            <ion-input label="Sértett fél" label-placement="stacked" [(ngModel)]="fej.sertett_fel"></ion-input>
          </div>
          <ion-toggle [(ngModel)]="fej.tanulo_kerte" labelPlacement="end">A tanuló maga ellen kérte</ion-toggle>
          <div class="fe-gombsor">
            <ion-button size="small" (click)="fejMent()">Mentés</ion-button>
            <ion-button size="small" fill="clear" (click)="fejSzerkeszt = false">Mégsem</ion-button>
          </div>
        </div>
      </div>

      <!-- Határidők -->
      <h4>Határidők</h4>
      <table class="fe-tabla" *ngIf="adatlap.hataridok?.length; else nincsHatarido">
        <tbody>
          <tr *ngFor="let h of adatlap.hataridok" [class.fe-kesz]="h.kesz">
            <td style="white-space:nowrap"><b>{{ h.datum }}</b></td>
            <td>{{ h.mi }}<br><small>{{ h.jog }}</small></td>
            <td><ion-badge color="success" *ngIf="h.kesz">teljesült</ion-badge></td>
          </tr>
        </tbody>
      </table>
      <ng-template #nincsHatarido><p class="fe-megj">A kötelességszegés napja után számolunk határidőt.</p></ng-template>

      <!-- Véglegessé vált kizárás: a jogviszony lezárása (kiléptetés) és így a KIR-bejelentés. -->
      <div class="fe-figy" *ngIf="adatlap.kileptetes">
        {{ adatlap.kileptetes.szoveg }}
        <ion-button *ngIf="adatlap.kileptetes.nyitott && adatlap.kezel" size="small" fill="outline" color="danger" (click)="kileptetesNyit()">
          Kiléptetés
        </ion-button>
      </div>

      <!-- Lépések -->
      <h4>Lépések</h4>
      <div *ngIf="!adatlap.lepesek?.length" class="fe-megj">Még nincs rögzített lépés.</div>
      <div class="fe-lepes" *ngFor="let l of adatlap.lepesek" [class.fe-visszavont]="l.visszavonva == 1">
        <div class="fe-lepes-fej">
          <b>{{ l.nev }}</b> · {{ l.datum }}
          <ion-badge color="medium" *ngIf="l.visszavonva == 1">visszavonva</ion-badge>
          <small> – rögzítette: {{ l.rogzitette }} ({{ l.rogzitve }})</small>
        </div>
        <small class="fe-jog" *ngIf="l.jog">{{ l.jog }}</small>
        <div class="fe-lepes-adat">
          <span *ngIf="l.adatok?.targyalas_ido">Tárgyalás: <b>{{ l.adatok.targyalas_ido }}</b>, {{ l.adatok.targyalas_hely }}<br></span>
          <span *ngIf="l.adatok?.postai_kuldes">Postázva: {{ l.adatok.postai_kuldes }}<br></span>
          <span *ngIf="l.adatok?.postai_kezhezvetel">Postai kézhezvétel: {{ l.adatok.postai_kezhezvetel }}<br></span>
          <span *ngIf="l.adatok?.valasz">Válasz: {{ l.adatok.valasz }}<br></span>
          <span *ngIf="l.adatok?.eredmeny">Eredmény: {{ l.adatok.eredmeny }}{{ l.adatok.felfuggesztes_ig ? ', felfüggesztve ' + l.adatok.felfuggesztes_ig + '-ig' : '' }}<br></span>
          <span *ngIf="l.adatok?.dontes && l.fajta === 'hatarozat'">
            Döntés: <b>{{ l.adatok.dontes === 'megszuntetes' ? 'megszüntetés – ' + okNev(l.adatok.megszuntetes_ok) : buntetesNev(l.adatok.buntetes) }}</b>
            {{ l.adatok.hatalya_ig ? '· hatálya: ' + l.adatok.hatalya_ig : '' }}
            {{ l.adatok.felfuggesztes_honap ? '· felfüggesztve ' + l.adatok.felfuggesztes_honap + ' hónapra' : '' }}
            {{ l.adatok.azonnal_vegrehajthato ? '· azonnal végrehajtható' : '' }}<br>
          </span>
          <span *ngIf="l.megjegyzes" class="fe-pre">Belső megjegyzés: {{ l.megjegyzes }}<br></span>
          <span *ngIf="l.visszavonva == 1">Visszavonta: {{ l.visszavonta }} ({{ l.visszavonva_ido }}) – {{ l.visszavonas_oka }}</span>
        </div>
        <div class="fe-ertesites" [class.hiba]="l.ertesites === 'hiba'" *ngIf="l.ertesites !== 'nincs'">
          <ion-icon name="notifications-outline"></ion-icon>
          Értesítés{{ l.ertesitve ? ' (' + l.ertesitve + ')' : '' }}: {{ ertesitesSzoveg(l) }}
          <ion-button size="small" fill="clear" *ngIf="l.csaladi_html" (click)="csaladiSzovegNyitva[l.id] = !csaladiSzovegNyitva[l.id]">
            {{ csaladiSzovegNyitva[l.id] ? 'Elrejt' : 'Mi ment ki?' }}
          </ion-button>
          <ion-button size="small" fill="outline" *ngIf="adatlap.kezel && l.ertesites === 'hiba' && l.visszavonva != 1" (click)="ujrakuld(l)">Újraküldés</ion-button>
          <div class="fe-csaladi" *ngIf="csaladiSzovegNyitva[l.id]" [innerHTML]="l.csaladi_html"></div>
        </div>
        <div class="fe-gombsor" *ngIf="adatlap.kezel && l.visszavonva != 1">
          <ion-button size="small" fill="outline" *ngIf="l.ertesites === 'nincs'" (click)="ujrakuld(l)">Értesítés küldése utólag</ion-button>
          <ion-button size="small" fill="clear" color="danger" (click)="visszavon(l)">Visszavonás</ion-button>
        </div>
      </div>

      <!-- Új lépés -->
      <div class="fe-urlap" *ngIf="adatlap.kezel && adatlap.eljaras.torolve != 1">
        <h4>Új lépés</h4>
        <div class="fe-mezok">
          <ion-select label="Lépés" label-placement="stacked" interface="popover" [(ngModel)]="lepesUrlap.fajta" (ionChange)="fajtaValt()">
            <ion-select-option *ngFor="let f of fajtaLista" [value]="f.kulcs">{{ f.nev }}{{ f.kotelezo ? ' (kötelező értesítés)' : '' }}</ion-select-option>
          </ion-select>
          <ion-input [label]="napLabel(lepesUrlap.fajta)" label-placement="stacked" type="date" [(ngModel)]="lepesUrlap.datum"></ion-input>
        </div>
        <p class="fe-megj" *ngIf="aktFajta?.jog">Jogalap: {{ aktFajta.jog }}</p>

        <ng-container [ngSwitch]="lepesUrlap.fajta">
          <div *ngSwitchCase="'egyezteto_felajanlas'" class="fe-mezok">
            <ion-input label="Postai értesítés feladása" label-placement="stacked" type="date" [(ngModel)]="lepesUrlap.adatok.postai_kuldes"></ion-input>
            <ion-input label="Postai kézhezvétel (ha már ismert)" label-placement="stacked" type="date" [(ngModel)]="lepesUrlap.adatok.postai_kezhezvetel"
                       helperText="Ettől számít az öt tanítási nap (53. § (3))"></ion-input>
          </div>
          <div *ngSwitchCase="'egyezteto_valasz'" class="fe-mezok">
            <ion-select label="Válasz" label-placement="stacked" interface="popover" [(ngModel)]="lepesUrlap.adatok.valasz">
              <ion-select-option value="kerte">Kérte az egyeztető eljárást</ion-select-option>
              <ion-select-option value="nem_kerte">Nem kérte</ion-select-option>
              <ion-select-option value="nem_valaszolt">A határidőn belül nem kérte</ion-select-option>
              <ion-select-option value="elutasitva">Elutasítva – harmadszori kötelességszegés (53. § (4))</ion-select-option>
            </ion-select>
            <ion-input label="A bejelentés beérkezésének napja" label-placement="stacked" type="date" [(ngModel)]="lepesUrlap.adatok.bejelentes_napja"
                       helperText="Ettől számít a tizenöt nap (53. § (3))"></ion-input>
          </div>
          <div *ngSwitchCase="'egyezteto_eredmeny'" class="fe-mezok">
            <ion-select label="Eredmény" label-placement="stacked" interface="popover" [(ngModel)]="lepesUrlap.adatok.eredmeny">
              <ion-select-option value="megallapodas">Írásbeli megállapodás – felfüggesztés (53. § (5))</ion-select-option>
              <ion-select-option value="eredmenytelen">Nem vezetett eredményre</ion-select-option>
            </ion-select>
            <ion-input *ngIf="lepesUrlap.adatok.eredmeny === 'megallapodas'" label="Felfüggesztés vége (legfeljebb 3 hónap)" label-placement="stacked"
                       type="date" [(ngModel)]="lepesUrlap.adatok.felfuggesztes_ig"></ion-input>
          </div>
          <div *ngSwitchCase="'felfuggesztes_vege'" class="fe-mezok">
            <ion-select label="Kimenet" label-placement="stacked" interface="popover" [(ngModel)]="lepesUrlap.adatok.kimenet">
              <ion-select-option value="folytatas">A sértett kérte a folytatást</ion-select-option>
              <ion-select-option value="megszuntetes">Nem kérte – az eljárás megszűnik</ion-select-option>
            </ion-select>
          </div>
          <div *ngSwitchCase="'meginditas'">
            <ion-textarea label="A tanuló terhére rótt kötelességszegés (az értesítésbe kerül)" label-placement="stacked" [autoGrow]="true"
                          [(ngModel)]="lepesUrlap.adatok.kotelessegszeges"></ion-textarea>
            <div class="fe-mezok">
              <ion-input label="A tárgyalás időpontja" label-placement="stacked" type="datetime-local" [(ngModel)]="lepesUrlap.adatok.targyalas_ido"
                         helperText="A postai értesítést legalább 8 nappal előtte meg kell kapniuk (56. § (2))"></ion-input>
              <ion-input label="A tárgyalás helye" label-placement="stacked" [(ngModel)]="lepesUrlap.adatok.targyalas_hely"></ion-input>
              <ion-input label="Postai értesítés feladása" label-placement="stacked" type="date" [(ngModel)]="lepesUrlap.adatok.postai_kuldes"></ion-input>
            </div>
          </div>
          <div *ngSwitchCase="'targyalas'" class="fe-mezok">
            <ion-input label="A tárgyalás (új) időpontja" label-placement="stacked" type="datetime-local" [(ngModel)]="lepesUrlap.adatok.targyalas_ido"></ion-input>
            <ion-input label="A tárgyalás helye" label-placement="stacked" [(ngModel)]="lepesUrlap.adatok.targyalas_hely"></ion-input>
            <ion-input label="Postai meghívó feladása" label-placement="stacked" type="date" [(ngModel)]="lepesUrlap.adatok.postai_kuldes"></ion-input>
          </div>
          <div *ngSwitchCase="'targyalas_megtartva'" class="fe-jelolok">
            <ion-toggle [(ngModel)]="lepesUrlap.adatok.dok_velemeny" labelPlacement="end">A diákönkormányzat véleménye beszerezve (57. § (3))</ion-toggle>
            <ion-toggle [(ngModel)]="lepesUrlap.adatok.jegyzokonyv" labelPlacement="end">Jegyzőkönyv készült (56. § (6)) – csatold iratként</ion-toggle>
          </div>
          <div *ngSwitchCase="'hatarozat'">
            <div class="fe-mezok">
              <ion-select label="Döntés" label-placement="stacked" interface="popover" [(ngModel)]="lepesUrlap.adatok.dontes">
                <ion-select-option value="buntetes">Fegyelmi büntetés (Nkt. 58. § (4))</ion-select-option>
                <ion-select-option value="megszuntetes">Az eljárás megszüntetése (58. § (2))</ion-select-option>
              </ion-select>
              <ion-select *ngIf="lepesUrlap.adatok.dontes === 'buntetes'" label="Büntetés" label-placement="stacked" interface="popover"
                          [(ngModel)]="lepesUrlap.adatok.buntetes">
                <ion-select-option *ngFor="let b of buntetesLista" [value]="b.kulcs">{{ b.nev }}</ion-select-option>
              </ion-select>
              <ion-select *ngIf="lepesUrlap.adatok.dontes === 'megszuntetes'" label="A megszüntetés oka" label-placement="stacked" interface="popover"
                          [(ngModel)]="lepesUrlap.adatok.megszuntetes_ok">
                <ion-select-option *ngFor="let o of okLista" [value]="o.kulcs">{{ o.nev }}</ion-select-option>
              </ion-select>
              <ion-input *ngIf="lepesUrlap.adatok.dontes === 'buntetes' && hatalyMax(lepesUrlap.adatok.buntetes)"
                         label="A büntetés hatálya eddig" label-placement="stacked" type="date" [(ngModel)]="lepesUrlap.adatok.hatalya_ig"
                         [helperText]="'Legfeljebb ' + hatalyMax(lepesUrlap.adatok.buntetes) + ' hónap (55. § (4))'"></ion-input>
              <ion-input *ngIf="lepesUrlap.adatok.dontes === 'buntetes'" label="Végrehajtás felfüggesztése (hónap, 0–6)" label-placement="stacked"
                         type="number" min="0" max="6" [(ngModel)]="lepesUrlap.adatok.felfuggesztes_honap"></ion-input>
              <ion-input label="A határozat száma" label-placement="stacked" [(ngModel)]="lepesUrlap.adatok.hatarozat_szam"></ion-input>
            </div>
            <ion-toggle *ngIf="lepesUrlap.adatok.dontes === 'buntetes'" [(ngModel)]="lepesUrlap.adatok.azonnal_vegrehajthato" labelPlacement="end">
              Azonnal végrehajtható (Nkt. 58. § (13): ha az elmaradás a többi tanuló jogait súlyosan sértené)
            </ion-toggle>
            <ion-textarea label="A rendelkező rész (az értesítésbe kerül)" label-placement="stacked" [autoGrow]="true"
                          [(ngModel)]="lepesUrlap.adatok.rendelkezo_resz"></ion-textarea>
          </div>
          <div *ngSwitchCase="'kozles'" class="fe-jelolok">
            <ion-toggle [(ngModel)]="lepesUrlap.adatok.lemondott" labelPlacement="end">
              A tanuló (kiskorúnál a szülő is) lemondott az eljárást megindító kérelmi jogáról (58. § (4), Nkt. 38. § (5))
            </ion-toggle>
          </div>
          <div *ngSwitchCase="'fellebbezes'" class="fe-mezok">
            <ion-input label="Benyújtó" label-placement="stacked" [(ngModel)]="lepesUrlap.adatok.benyujto"></ion-input>
          </div>
          <div *ngSwitchCase="'masodfok'" class="fe-mezok">
            <ion-select label="Másodfokú döntés" label-placement="stacked" interface="popover" [(ngModel)]="lepesUrlap.adatok.dontes">
              <ion-select-option value="elutasitva">A kérelmet elutasította</ion-select-option>
              <ion-select-option value="megvaltoztatva">A döntést megváltoztatta</ion-select-option>
              <ion-select-option value="megsemmisitve">Megsemmisítette, új döntésre utasított</ion-select-option>
            </ion-select>
            <ion-select *ngIf="lepesUrlap.adatok.dontes === 'megvaltoztatva'" label="Új döntés" label-placement="stacked" interface="popover"
                        [(ngModel)]="lepesUrlap.adatok.uj_dontes">
              <ion-select-option value="buntetes">Büntetés</ion-select-option>
              <ion-select-option value="megszuntetes">Megszüntetés</ion-select-option>
            </ion-select>
            <ion-select *ngIf="lepesUrlap.adatok.uj_dontes === 'buntetes'" label="Büntetés" label-placement="stacked" interface="popover"
                        [(ngModel)]="lepesUrlap.adatok.buntetes">
              <ion-select-option *ngFor="let b of buntetesLista" [value]="b.kulcs">{{ b.nev }}</ion-select-option>
            </ion-select>
            <ion-input label="A döntés száma" label-placement="stacked" [(ngModel)]="lepesUrlap.adatok.dontes_szam"></ion-input>
          </div>
        </ng-container>

        <ion-textarea label="Üzenet a családnak (az értesítésbe kerül, elhagyható)" label-placement="stacked" [autoGrow]="true"
                      [(ngModel)]="lepesUrlap.adatok.csaladnak"></ion-textarea>
        <ion-textarea label="Belső megjegyzés (a családnak nem megy ki)" label-placement="stacked" [autoGrow]="true"
                      [(ngModel)]="lepesUrlap.megjegyzes"></ion-textarea>

        <ion-toggle [(ngModel)]="lepesUrlap.ertesites" [disabled]="!!aktFajta?.kotelezo" labelPlacement="end">
          Értesítés a tanulónak és a gondviselőknek
          <small *ngIf="aktFajta?.kotelezo">(kötelező – a jogszabály a tanulmányi rendszeren keresztüli értesítést írja elő)</small>
        </ion-toggle>
        <p class="fe-figy" *ngIf="lepesUrlap.ertesites">
          {{ jog?.nem_kozles }}
        </p>
        <div class="fe-gombsor">
          <ion-button size="small" (click)="lepesMent()" [disabled]="mentes || !lepesUrlap.fajta">
            <ion-icon slot="start" name="save-outline"></ion-icon>{{ lepesUrlap.ertesites ? 'Rögzítés és értesítés' : 'Rögzítés' }}
          </ion-button>
        </div>
      </div>

      <!-- Iratok -->
      <h4>Iratok</h4>
      <div class="fe-irat" *ngFor="let i of adatlap.iratok">
        <a href="javascript:void(0)" (click)="iratMegnyit(i)"><ion-icon name="document-outline"></ion-icon> {{ i.nev }}</a>
        <small> – {{ i.feltoltotte }}, {{ i.feltoltve }}</small>
        <ion-button size="small" fill="clear" color="danger" *ngIf="adatlap.kezel" (click)="iratTorol(i)">Törlés</ion-button>
      </div>
      <p class="fe-megj" *ngIf="!adatlap.iratok?.length">Nincs csatolt irat (határozat, jegyzőkönyv, tértivevény…).</p>
      <div *ngIf="adatlap.kezel" class="fe-gombsor">
        <input type="file" (change)="iratFeltolt($event)" />
      </div>

      <!-- Napló -->
      <ng-container *ngIf="adatlap.kezel">
        <h4>
          Napló
          <ion-button size="small" fill="clear" (click)="naploNyitva = !naploNyitva">{{ naploNyitva ? 'Elrejt' : 'Mutat' }}</ion-button>
        </h4>
        <table class="fe-tabla" *ngIf="naploNyitva">
          <tbody>
            <tr *ngFor="let n of adatlap.naplo">
              <td style="white-space:nowrap">{{ n.mikor }}</td><td>{{ n.ki }}</td><td>{{ n.muvelet }}</td>
              <td class="fe-naplo-reszlet">{{ n.reszlet }}</td>
            </tr>
          </tbody>
        </table>
      </ng-container>
    </ng-container>
  </ion-card-content>
</ion-card>
</ng-template>
